module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_1000_Inactive@1x-8549df65b05f3275f7f33a107d615e7b.png";